import cloneDeep from "lodash-es/cloneDeep";

const state = {
  product: {},
  selectedOptions: [],
  wishlist: [],
  selectedVariant: null,
  defaultVariant: null,
  openSizeGuide: false,
};

const getters = {
  selectedOptionsWithoutId: (state) => {
    return state.selectedOptions.map(({ name, value }) => ({
      name,
      value,
    }));
  },
  productOptions: (state) => {
    return state.product.options;
  },
  top2Wishlist: (state) => {
    const wishlist = cloneDeep(state.wishlist);
    return wishlist.reverse().slice(0, 2);
  },
  variant: (state) => {
    return state.selectedVariant || state.defaultVariant;
  },
  price: (_, getters) => {
    return getters.variant.priceV2;
  },
  originalPrice: (state) => {
    return state.product.compareAtPriceRange.minVariantPrice;
  },
  isOnSale: (_, getters) => {
    return (
      parseFloat(getters.originalPrice.amount) >
      parseFloat(getters.price.amount)
    );
  },
};

const mutations = {
  setSelectedOptions(state, value) {
    state.selectedOptions = value;
  },
  setProduct(state, value) {
    state.product = value;
  },
  setWishlist(state, value) {
    state.wishlist = value;
  },
  setSelectedVariant(state, value) {
    state.selectedVariant = value;
  },
  setDefaultVariant(state, value) {
    state.defaultVariant = value;
  },
  setOpenSizeGuide(state, value) {
    state.openSizeGuide = value;
  },
};

const actions = {
  changeProductOption({ commit, state, dispatch }, option) {
    const selectedOptions = cloneDeep(state.selectedOptions);
    const index = selectedOptions.findIndex(
      (selectedOption) => selectedOption.id === option.id
    );

    if (index === -1) {
      selectedOptions.push(option);
    } else {
      selectedOptions[index] = option;
    }

    commit("setSelectedOptions", selectedOptions);

    dispatch("updateProductUrl");
  },
  setSelectedOptions({ commit }, options) {
    commit("setSelectedOptions", options);
  },
  async removeFromWishList({ rootState }, productId) {
    const customerId = rootState.auth.customer.id;

    await fetch(
      `${process.env.RATANDBOA_NODE_APP_URL}/customer/wishlist/remove`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerId,
          productId,
        }),
      }
    );
  },
  updateProductUrl({ state, getters }) {
    const selectedOptions = cloneDeep(state.selectedOptions);
    const url = new URL(window.location);
    selectedOptions.forEach((selectedOption) => {
      const actualOption = getters.productOptions.find((productOption) => {
        return productOption.id === selectedOption.id;
      });

      if (actualOption.values.length > 1) {
        url.searchParams.set(
          selectedOption.name.toLowerCase(),
          selectedOption.value.toLowerCase()
        );
      }
    });

    window.history.replaceState(null, "", url.toString());
  },
  setProduct({ commit }, product) {
    commit("setProduct", product);
  },
  async getWishlistProducts({ commit, rootState }) {
    const customerId = rootState.auth.customer.id;

    if (!customerId) {
      return;
    }

    const response = await fetch(
      `${process.env.RATANDBOA_NODE_APP_URL}/customer/wishlist?customerId=${customerId}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      return;
    }

    const json = await response.json();

    commit("setWishlist", json);
  },
  setSelectedVariant({ commit }, value) {
    commit("setSelectedVariant", value);
  },
  setDefaultVariant({ commit }, value) {
    commit("setDefaultVariant", value);
  },
  setOpenSizeGuide({ commit }, value) {
    commit("setOpenSizeGuide", value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
